import {
  SET_EVENT_VIEW,
  SET_EVENT_CATEGORIES,
  SET_EVENT_LOCATIONS,
  SET_EVENT_START_DATE,
  SET_EVENT_END_DATE
} from '../actions/setFilters'

import moment from 'moment'
import { first, isArray } from 'lodash'

const initialState = {
  view: 'daily',
  categories: [],
  locations: [],
  startDate: moment().format('YYYY-MM-DD'),
  endDate: ''
}

export default function filtersData(state = initialState, action) {
  switch (action.type) {
    case SET_EVENT_VIEW:
      return {
        ...state,
        view: action.payload
      }
    case SET_EVENT_CATEGORIES:
      return {
        ...state,
        categories: isArray(action.payload) ? action.payload : [action.payload]
      }
    case SET_EVENT_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      }
    case SET_EVENT_START_DATE:
      return {
        ...state,
        startDate: action.payload
      }
    case SET_EVENT_END_DATE:
      return {
        ...state,
        endDate: action.payload
      }
    default:
      return state
  }
}

export const getCategoryFilterData = state => first(state.filtersData.categories) || ''
export const getCategoriesFilterData = state => state.filtersData.categories
export const getCurrentViewData = state => state.filtersData.view
export const getLocationsFilterData = (state) => state.filtersData.locations
